import { Text, useDisclosure } from '@chakra-ui/react';
import { MenuItem } from 'components/v4';
import { TenantIcon } from './TenantIcon';
import { IconComponent } from '../IconComponent';
import ServiceDashboardTenantId from 'components/v4/Services/ServiceDashboard/ServiceDashboardTenantId';

const OCMenuItems = ({
    cardStatus,
    darkMode,
    handleGrantAccess,
    service,
    serviceObj,
    serviceWizard,
}) => {
    const modalState = useDisclosure();

    const hasTenantId =
        cardStatus?.showTenantId && serviceObj?.authPolicy !== 2;
    const hasProvideAccess =
        cardStatus?.grantAccess && serviceObj?.authPolicy !== 0;

    // Return null if no menu items will be displayed
    if (!hasTenantId && !hasProvideAccess) {
        return null;
    }

    return (
        <>
            <ServiceDashboardTenantId {...modalState} {...serviceWizard} />
            {/* Tenant ID */}
            {hasTenantId && (
                <MenuItem
                    id="tenant-id"
                    icon={<TenantIcon color={darkMode ? 'white' : 'black'} />}
                    onClick={() => {
                        modalState.onOpen();
                    }}
                    data-walkthroughid={`/dashboard-services/card/${service.name}/tenant-id`}>
                    <Text marginBottom="0">Tenant ID</Text>
                </MenuItem>
            )}

            {/* Provide Access */}
            {hasProvideAccess && (
                <MenuItem
                    id="oc-provide-access"
                    icon={
                        <IconComponent
                            icon="Settings"
                            color={darkMode ? 'white' : 'black'}
                        />
                    }
                    onClick={handleGrantAccess}
                    data-walkthroughid={`/dashboard-services/card/${service.name}/provide-access`}>
                    <Text marginBottom="0">Grant Access</Text>
                </MenuItem>
            )}
        </>
    );
};

export default OCMenuItems;
